var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLongDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 2C12.6326 2 12.7598 2.05268 12.8536 2.14645C12.9473 2.24021 13 2.36739 13 2.5V18H15C15.0979 18.0014 15.1932 18.0314 15.2741 18.0865C15.3551 18.1415 15.4181 18.2191 15.4553 18.3096C15.4926 18.4001 15.5025 18.4995 15.4838 18.5956C15.465 18.6917 15.4185 18.7801 15.35 18.85L12.35 21.85C12.2549 21.9422 12.1275 21.9938 11.995 21.9938C11.8625 21.9938 11.7352 21.9422 11.64 21.85L8.64001 18.85C8.57091 18.7795 8.52422 18.6901 8.50582 18.5931C8.48743 18.4962 8.49816 18.3959 8.53666 18.305C8.57516 18.2141 8.6397 18.1366 8.72216 18.0823C8.80462 18.0281 8.90129 17.9994 9.00001 18H11V2.5C11 2.36739 11.0527 2.24021 11.1465 2.14645C11.2402 2.05268 11.3674 2 11.5 2H12.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLongDown);
export default __webpack_public_path__ + "static/media/arrowLongDown.527d61cc91c4ac420b42314af64d78aa.svg";
export { ForwardRef as ReactComponent };